import { render } from "./TinySlider.vue?vue&type=template&id=802534b4"
import script from "./TinySlider.vue?vue&type=script&lang=js"
export * from "./TinySlider.vue?vue&type=script&lang=js"
script.render = render

export default script